import {
    CORE_LOAD_ORDERS_REQUEST,
    CORE_LOAD_ORDERS_SUCCESS,
    CORE_LOAD_ORDERS_FAILURE,

    CORE_CREATE_AMENITY_REQUEST,
    CORE_CREATE_AMENITY_SUCCESS,
    CORE_CREATE_AMENITY_FAILURE,

    CORE_FIND_ROOM_REQUEST,
    CORE_FIND_ROOM_SUCCESS,
    CORE_FIND_ROOM_FAILURE,

    CORE_DELETE_ROOM_REQUEST,
    CORE_DELETE_ROOM_SUCCESS,
    CORE_DELETE_ROOM_FAILURE,

    CORE_LOAD_USER_REQUEST,
    CORE_LOAD_USER_SUCCESS,
    CORE_LOAD_USER_FAILURE,

    CORE_LOAD_USERS_REQUEST,
    CORE_LOAD_USERS_SUCCESS,
    CORE_LOAD_USERS_FAILURE,

    CORE_UPDATE_USER_REQUEST,
    CORE_UPDATE_USER_SUCCESS,
    CORE_UPDATE_USER_FAILURE,

    CORE_DELETE_USER_REQUEST,
    CORE_DELETE_USER_SUCCESS,
    CORE_DELETE_USER_FAILURE,

    CORE_LOAD_ALLROOM_REQUEST,
    CORE_LOAD_ALLROOM_SUCCESS,
    CORE_LOAD_ALLROOM_FAILURE,

    CORE_UPDATE_ROOM_REQUEST,
    CORE_UPDATE_ROOM_SUCCESS,
    CORE_UPDATE_ROOM_FAILURE,

    CORE_CREATE_BUILDING_REQUEST,
    CORE_CREATE_BUILDING_SUCCESS,
    CORE_CREATE_BUILDING_FAILURE,

    CORE_EDIT_BUILDING_REQUEST,
    CORE_EDIT_BUILDING_SUCCESS,
    CORE_EDIT_BUILDING_FAILURE,

    CORE_CREATE_ROOM_REQUEST,
    CORE_CREATE_ROOM_SUCCESS,
    CORE_CREATE_ROOM_FAILURE,

    CORE_LOAD_FBS_REQUEST,
    CORE_LOAD_FBS_SUCCESS,
    CORE_LOAD_FBS_FAILURE,

    CORE_CREATE_FBS_REQUEST,
    CORE_CREATE_FBS_SUCCESS,
    CORE_CREATE_FBS_FAILURE,

    CORE_LOAD_ALL_FLOOR_REQUEST,
    CORE_LOAD_ALL_FLOOR_SUCCESS,
    CORE_LOAD_ALL_FLOOR_FAILURE,

    CORE_LOAD_ALL_AMENITIES_REQUEST,
    CORE_LOAD_ALL_AMENITIES_SUCCESS,
    CORE_LOAD_ALL_AMENITIES_FAILURE,

    CORE_CREATE_FLOOR_REQUEST,
    CORE_CREATE_FLOOR_SUCCESS,
    CORE_CREATE_FLOOR_FAILURE,

    CORE_LOAD_LOCAL_USERS_REQUEST,
    CORE_LOAD_LOCAL_USERS_SUCCESS,
    CORE_LOAD_LOCAL_USERS_FAILURE,

    CORE_CHANGE_PASSWORD_REQUEST,
    CORE_CHANGE_PASSWORD_SUCCESS,
    CORE_CHANGE_PASSWORD_FAILURE,

    BSRS_LOGIN_REQUEST,
    BSRS_LOGIN_SUCCESS,
    BSRS_LOGIN_FAILURE,

    CORE_CREATE_USER_REQUEST,
    CORE_CREATE_USER_SUCCESS,
    CORE_CREATE_USER_FAILURE,

    CORE_EDIT_SYNC_REQUEST,
    CORE_EDIT_SYNC_SUCCESS,
    CORE_EDIT_SYNC_FAILURE,

    CORE_RESET_PASSWORD_REQUEST,
    CORE_RESET_PASSWORD_SUCCESS,
    CORE_RESET_PASSWORD_FAILURE,

    CORE_LOAD_ROOM_REQUEST,
    CORE_LOAD_ROOM_SUCCESS,
    CORE_LOAD_ROOM_FAILURE,

    CORE_LOAD_ROOMS_REQUEST,
    CORE_LOAD_ROOMS_SUCCESS,
    CORE_LOAD_ROOMS_FAILURE,

    CORE_LOAD_DISABLE_ROOM_REQUEST,
    CORE_LOAD_DISABLE_ROOM_SUCCESS,
    CORE_LOAD_DISABLE_ROOM_FAILURE,

    CORE_LOAD_EXECUTIVE_ROOM_REQUEST,
    CORE_LOAD_EXECUTIVE_ROOM_SUCCESS,
    CORE_LOAD_EXECUTIVE_ROOM_FAILURE,

    CORE_CREATE_ROLE_REQUEST,
    CORE_CREATE_ROLE_SUCCESS,
    CORE_CREATE_ROLE_FAILURE,

    CORE_EDIT_ROLE_REQUEST,
    CORE_EDIT_ROLE_SUCCESS,
    CORE_EDIT_ROLE_FAILURE,

    CORE_LOAD_ALL_ROLE_REQUEST,
    CORE_LOAD_ALL_ROLE_SUCCESS,
    CORE_LOAD_ALL_ROLE_FAILURE,

    CORE_LOAD_ROLE_REQUEST,
    CORE_LOAD_ROLE_SUCCESS,
    CORE_LOAD_ROLE_FAILURE,

    CORE_DELETE_ROLE_REQUEST,
    CORE_DELETE_ROLE_SUCCESS,
    CORE_DELETE_ROLE_FAILURE,

    CORE_LOAD_ALL_FBS_CATEGORY_REQUEST,
    CORE_LOAD_ALL_FBS_CATEGORY_SUCCESS,
    CORE_LOAD_ALL_FBS_CATEGORY_FAILURE,

    CORE_LOAD_ALL_BUILDINGS_REQUEST,
    CORE_LOAD_ALL_BUILDINGS_SUCCESS,
    CORE_LOAD_ALL_BUILDINGS_FAILURE,

    CORE_LOAD_EVENTREPORT_REQUEST,
    CORE_LOAD_EVENTREPORT_SUCCESS,
    CORE_LOAD_EVENTREPORT_FAILURE,

    CORE_CANCEL_EVENT_REQUEST,
    CORE_CANCEL_EVENT_SUCCESS,
    CORE_CANCEL_EVENT_FAILURE,

    CORE_LOAD_ALL_FBS_REQUEST,
    CORE_LOAD_ALL_FBS_SUCCESS,
    CORE_LOAD_ALL_FBS_FAILURE,

    CORE_LOAD_ALL_TITLE_REQUEST,
    CORE_LOAD_ALL_TITLE_SUCCESS,
    CORE_LOAD_ALL_TITLE_FAILURE,

    CORE_LOAD_ALL_ROOMFORMATS_REQUEST,
    CORE_LOAD_ALL_ROOMFORMATS_SUCCESS,
    CORE_LOAD_ALL_ROOMFORMATS_FAILURE,

    CORE_LOAD_ALL_ROOMTYPE_REQUEST,
    CORE_LOAD_ALL_ROOMTYPE_SUCCESS,
    CORE_LOAD_ALL_ROOMTYPE_FAILURE,

    CORE_LOAD_SETTING_REQUEST,
    CORE_LOAD_SETTING_SUCCESS,
    CORE_LOAD_SETTING_FAILURE,

    CORE_SEARCH_EVENTS_REQUEST,
    CORE_SEARCH_EVENTS_SUCCESS,
    CORE_SEARCH_EVENTS_FAILURE,

    CORE_LOAD_PRIVATE_ROOM_REQUEST,
    CORE_LOAD_PRIVATE_ROOM_SUCCESS,
    CORE_LOAD_PRIVATE_ROOM_FAILURE,

    CORE_LOAD_ROOM_GROUP_BY_TYPE_REQUEST,
    CORE_LOAD_ROOM_GROUP_BY_TYPE_SUCCESS,
    CORE_LOAD_ROOM_GROUP_BY_TYPE_FAILURE,

    CORE_LOAD_DISABLE_ROOMS_REQUEST,
    CORE_LOAD_DISABLE_ROOMS_SUCCESS,
    CORE_LOAD_DISABLE_ROOMS_FAILURE,

    CORE_IMPORT_USER_FILE_REQUEST,
    CORE_IMPORT_USER_FILE_SUCCESS,
    CORE_IMPORT_USER_FILE_FAILURE,

    CORE_REOPEN_EVENT_REQUEST,
    CORE_REOPEN_EVENT_SUCCESS,
    CORE_REOPEN_EVENT_FAILURE,

    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST,
    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS,
    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE,

    CORE_LOAD_SYNC_USER_REQUEST,
    CORE_LOAD_SYNC_USER_SUCCESS,
    CORE_LOAD_SYNC_USER_FAILURE,

    CORE_LOAD_BUILDING_REQUEST,
    CORE_LOAD_BUILDING_SUCCESS,
    CORE_LOAD_BUILDING_FAILURE,

} from '../../types'

const initialState = {
    hasError: false,
    isLoading: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CORE_LOAD_ORDERS_REQUEST:
        case CORE_FIND_ROOM_REQUEST:
        case CORE_LOAD_USER_REQUEST:
        case CORE_UPDATE_USER_REQUEST:
        case CORE_DELETE_USER_REQUEST:
        case CORE_LOAD_USERS_REQUEST:
        case CORE_LOAD_ALLROOM_REQUEST:
        case CORE_UPDATE_ROOM_REQUEST:
        case CORE_LOAD_FBS_REQUEST:
        case CORE_CREATE_FBS_REQUEST:
        case CORE_LOAD_ALL_FLOOR_REQUEST:
        case CORE_CREATE_ROOM_REQUEST:
        case CORE_LOAD_ALL_AMENITIES_REQUEST:
        case CORE_CREATE_FLOOR_REQUEST:
        case CORE_LOAD_LOCAL_USERS_REQUEST:
        case BSRS_LOGIN_REQUEST:
        case CORE_CHANGE_PASSWORD_REQUEST:
        case CORE_CREATE_USER_REQUEST:
        case CORE_DELETE_ROOM_REQUEST:
        case CORE_EDIT_SYNC_REQUEST:
        case CORE_RESET_PASSWORD_REQUEST:
        case CORE_LOAD_ROOM_REQUEST:
        case CORE_LOAD_DISABLE_ROOM_REQUEST:
        case CORE_LOAD_EXECUTIVE_ROOM_REQUEST:
        case CORE_LOAD_ROLE_REQUEST:
        case CORE_LOAD_ALL_FBS_CATEGORY_REQUEST:
        case CORE_LOAD_ALL_BUILDINGS_REQUEST:
        case CORE_LOAD_EVENTREPORT_REQUEST:
        case CORE_CANCEL_EVENT_REQUEST:
        case CORE_LOAD_ROOMS_REQUEST:
        case CORE_LOAD_ALL_FBS_REQUEST:
        case CORE_LOAD_ALL_TITLE_REQUEST:
        case CORE_LOAD_ALL_ROOMFORMATS_REQUEST:
        case CORE_LOAD_ALL_ROOMTYPE_REQUEST:
        case CORE_LOAD_SETTING_REQUEST:
        case CORE_SEARCH_EVENTS_REQUEST:
        case CORE_LOAD_PRIVATE_ROOM_REQUEST:
        case CORE_LOAD_ROOM_GROUP_BY_TYPE_REQUEST:
        case CORE_CREATE_AMENITY_REQUEST:
        case CORE_CREATE_BUILDING_REQUEST:
        case CORE_EDIT_BUILDING_REQUEST:
        case CORE_LOAD_DISABLE_ROOMS_REQUEST:
        case CORE_IMPORT_USER_FILE_REQUEST:
        case CORE_REOPEN_EVENT_REQUEST:
        case CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST:
        case CORE_CREATE_ROLE_REQUEST:
        case CORE_EDIT_ROLE_REQUEST:
        case CORE_LOAD_ALL_ROLE_REQUEST:
        case CORE_DELETE_ROLE_REQUEST:
        case CORE_LOAD_SYNC_USER_REQUEST:
        case CORE_LOAD_BUILDING_REQUEST:
            return {
                ...state,
                isLoading: true,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            }
        case CORE_LOAD_ORDERS_SUCCESS:
        case CORE_FIND_ROOM_SUCCESS:
        case CORE_DELETE_ROOM_SUCCESS:
        case CORE_LOAD_USER_SUCCESS:
        case CORE_UPDATE_USER_SUCCESS:
        case CORE_DELETE_USER_SUCCESS:
        case CORE_LOAD_USERS_SUCCESS:
        case CORE_LOAD_ALLROOM_SUCCESS:
        case CORE_UPDATE_ROOM_SUCCESS:
        case CORE_LOAD_FBS_SUCCESS:
        case CORE_CREATE_FBS_SUCCESS:
        case CORE_LOAD_ALL_FLOOR_SUCCESS:
        case CORE_CREATE_ROOM_SUCCESS:
        case CORE_LOAD_ALL_AMENITIES_SUCCESS:
        case CORE_CREATE_FLOOR_SUCCESS:
        case CORE_LOAD_LOCAL_USERS_SUCCESS:
        case BSRS_LOGIN_SUCCESS:
        case CORE_CHANGE_PASSWORD_SUCCESS:
        case CORE_CREATE_USER_SUCCESS:
        case CORE_EDIT_SYNC_SUCCESS:
        case CORE_RESET_PASSWORD_SUCCESS:
        case CORE_LOAD_ROLE_SUCCESS:
        case CORE_LOAD_EXECUTIVE_ROOM_SUCCESS:
        case CORE_LOAD_DISABLE_ROOM_SUCCESS:
        case CORE_LOAD_ROOM_SUCCESS:
        case CORE_LOAD_ALL_FBS_CATEGORY_SUCCESS:
        case CORE_LOAD_ALL_BUILDINGS_SUCCESS:
        case CORE_LOAD_EVENTREPORT_SUCCESS:
        case CORE_CANCEL_EVENT_SUCCESS:
        case CORE_LOAD_ROOMS_SUCCESS:
        case CORE_LOAD_ALL_FBS_SUCCESS:
        case CORE_LOAD_ALL_TITLE_SUCCESS:
        case CORE_LOAD_ALL_ROOMFORMATS_SUCCESS:
        case CORE_LOAD_ALL_ROOMTYPE_SUCCESS:
        case CORE_LOAD_SETTING_SUCCESS:
        case CORE_SEARCH_EVENTS_SUCCESS:
        case CORE_LOAD_PRIVATE_ROOM_SUCCESS:
        case CORE_LOAD_ROOM_GROUP_BY_TYPE_SUCCESS:
        case CORE_CREATE_AMENITY_SUCCESS:
        case CORE_CREATE_BUILDING_SUCCESS:
        case CORE_EDIT_BUILDING_SUCCESS:
        case CORE_LOAD_DISABLE_ROOMS_SUCCESS:
        case CORE_IMPORT_USER_FILE_SUCCESS:
        case CORE_REOPEN_EVENT_SUCCESS:
        case CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS:
        case CORE_CREATE_ROLE_SUCCESS:
        case CORE_EDIT_ROLE_SUCCESS:
        case CORE_LOAD_ALL_ROLE_SUCCESS:
        case CORE_DELETE_ROLE_SUCCESS:
        case CORE_LOAD_SYNC_USER_SUCCESS:
        case CORE_LOAD_BUILDING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            }
        case CORE_LOAD_ORDERS_FAILURE:
        case CORE_FIND_ROOM_FAILURE:
        case CORE_DELETE_ROOM_FAILURE:
        case CORE_LOAD_USER_FAILURE:
        case CORE_UPDATE_USER_FAILURE:
        case CORE_DELETE_USER_FAILURE:
        case CORE_LOAD_USERS_FAILURE:
        case CORE_LOAD_ALLROOM_FAILURE:
        case CORE_UPDATE_ROOM_FAILURE:
        case CORE_LOAD_FBS_FAILURE:
        case CORE_CREATE_FBS_FAILURE:
        case CORE_LOAD_ALL_FLOOR_FAILURE:
        case CORE_CREATE_ROOM_FAILURE:
        case CORE_LOAD_ALL_AMENITIES_FAILURE:
        case CORE_CREATE_FLOOR_FAILURE:
        case CORE_LOAD_LOCAL_USERS_FAILURE:
        case BSRS_LOGIN_FAILURE:
        case CORE_CHANGE_PASSWORD_FAILURE:
        case CORE_CREATE_USER_FAILURE:
        case CORE_EDIT_SYNC_FAILURE:
        case CORE_RESET_PASSWORD_FAILURE:
        case CORE_LOAD_ROOM_FAILURE:
        case CORE_LOAD_DISABLE_ROOM_FAILURE:
        case CORE_LOAD_EXECUTIVE_ROOM_FAILURE:
        case CORE_LOAD_ROLE_FAILURE:
        case CORE_LOAD_ALL_FBS_CATEGORY_FAILURE:
        case CORE_LOAD_ALL_BUILDINGS_FAILURE:
        case CORE_LOAD_EVENTREPORT_FAILURE:
        case CORE_CANCEL_EVENT_FAILURE:
        case CORE_LOAD_ROOMS_FAILURE:
        case CORE_LOAD_ALL_FBS_FAILURE:
        case CORE_LOAD_ALL_TITLE_FAILURE:
        case CORE_LOAD_ALL_ROOMFORMATS_FAILURE:
        case CORE_LOAD_ALL_ROOMTYPE_FAILURE:
        case CORE_LOAD_SETTING_FAILURE:
        case CORE_SEARCH_EVENTS_FAILURE:
        case CORE_LOAD_PRIVATE_ROOM_FAILURE:
        case CORE_LOAD_ROOM_GROUP_BY_TYPE_FAILURE:
        case CORE_CREATE_AMENITY_FAILURE:
        case CORE_CREATE_BUILDING_FAILURE:
        case CORE_EDIT_BUILDING_FAILURE:
        case CORE_LOAD_DISABLE_ROOMS_FAILURE:
        case CORE_IMPORT_USER_FILE_FAILURE:
        case CORE_REOPEN_EVENT_FAILURE:
        case CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE:
        case CORE_CREATE_ROLE_FAILURE:
        case CORE_EDIT_ROLE_FAILURE:
        case CORE_LOAD_ALL_ROLE_FAILURE:
        case CORE_DELETE_ROLE_FAILURE:
        case CORE_LOAD_SYNC_USER_FAILURE:
        case CORE_LOAD_BUILDING_FAILURE:
            let { statusText, code, message, data } = action.payload
            if (data && data.code === "422") {
                message = data.message
                code = data.code
                statusText = data.code
            }
            let returnData = {
                ...state,
                isLoading: false,
                hasError: true,
                statusText: statusText,
                errorCode: code,
                errorMessage: message
            }
            return returnData
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/features/ui/reducer.js